import type { Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { ApplicationConfig } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: ApplicationConfig = {
  applicationId: 'UNKNOWN',
};

const reducer: Reducer<ApplicationConfig, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.application;
    default:
      return state;
  }
};

export default reducer;
